/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost$Params {
  parkingPlaceId: number;
      body?: Array<number>
}

export function apiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost(http: HttpClient, rootUrl: string, params: ApiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost.PATH, 'post');
  if (params) {
    rb.path('parkingPlaceId', params.parkingPlaceId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost.PATH = '/api/ParkingSpot/CmsUpdateParkingSpotsOrderPosition/{parkingPlaceId}';
